// Works out which assessment-configuration fields the admin actually changed in
// the Edit Assessment drawer, so the save payload carries only those.
//
// This matters beyond payload size: the drawer holds a mix of read-only and
// editable fields, and posting back the whole form would let a stale tab
// overwrite a job description or an interview length that someone else edited in
// the meantime. It also keeps the "No changes to save" path honest.
//
// Kept framework-free (plain CommonJS, no React) so it can be unit-tested with
// bare node — admin-react has no test runner. Same pattern as
// editAssessmentTarget.js.

// Config values are scalars or arrays of strings, so a JSON comparison is enough
// to tell a real edit from a value the form merely round-tripped. Null and
// undefined are treated as the same "not set".
function hasSameValue(a, b) {
  return JSON.stringify(a === undefined ? null : a) === JSON.stringify(b === undefined ? null : b)
}

// `configuration` is the payload from GET /assessment/details; `edits` is the
// drawer's pending { fieldKey: value } map. Only keys the server marked editable
// are eligible — a key the server never offered can never be sent.
function diffConfiguration(configuration, edits) {
  const original = {}
  const groups = (configuration && configuration.groups) || []
  groups.forEach((group) => {
    (group.fields || []).forEach((field) => {
      if (field.editable) original[field.key] = field.value
    })
  })

  return Object.keys(edits || {}).reduce((changed, key) => {
    if (key in original && !hasSameValue(original[key], edits[key])) {
      changed[key] = edits[key]
    }
    return changed
  }, {})
}

module.exports = { diffConfiguration, hasSameValue }
